<template>
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="40"
      cy="40"
      r="37"
      fill="var(--brandPrimaryLight)"
    />
    <circle
      cx="20.4316"
      cy="21.2184"
      r="16"
      fill="var(--systemSuccessLight)"
    />
    <path
      d="M27.4483 15.1604L21.0483 12.3476C20.8534 12.2623 20.6444 12.2184 20.4333 12.2184C20.2222 12.2184 20.0133 12.2623 19.8183 12.3476L13.4183 15.1604C12.8216 15.4206 12.4316 16.0358 12.4316 16.7179C12.4316 23.6971 16.2483 28.5211 19.815 30.0892C20.2083 30.2615 20.6516 30.2615 21.045 30.0892C23.9016 28.834 28.4316 24.4988 28.4316 16.7179C28.4316 16.0358 28.0416 15.4206 27.4483 15.1604ZM20.435 27.9093L20.4316 14.5134L26.295 17.0906C26.185 22.4138 23.5583 26.2708 20.435 27.9093Z"
      fill="var(--brandPrimary)"
    />
    <path
      d="M65.5958 20.4463L72.3818 38.4246C72.5567 38.8949 72.5312 39.4126 72.3108 39.8648C72.0904 40.3171 71.693 40.6674 71.2052 40.8392L35.6042 53.254C35.1156 53.4224 34.5776 53.3985 34.1072 53.1876C33.6369 52.9766 33.2722 52.5957 33.0925 52.1275L26.3065 34.1447C26.1304 33.6751 26.1555 33.1575 26.3761 32.7056C26.5967 32.2537 26.9949 31.9045 27.4831 31.7347L63.0841 19.3152C63.5733 19.1471 64.1118 19.1716 64.5823 19.3835C65.0528 19.5954 65.4171 19.9774 65.5958 20.4463Z"
      fill="var(--brandSecondary)"
    />
    <path
      d="M64.1464 19.3688L54.0117 35.9135C53.0732 37.4476 51.6344 38.6175 49.9339 39.2293C48.2333 39.8412 46.3731 39.8582 44.6614 39.2775L26.1904 33.024C26.413 32.5841 26.796 32.2448 27.2618 32.0751L62.7163 19.3119C63.1832 19.1514 63.694 19.1718 64.1464 19.3688Z"
      fill="var(--brandSecondary)"
    />
    <path
      opacity="0.5"
      d="M64.3569 19.2048L54.0117 35.9136C53.0732 37.4477 51.6344 38.6176 49.9339 39.2294C48.2333 39.8412 46.3731 39.8582 44.6614 39.2776L26.1904 33.0241C26.413 32.5841 26.6944 31.8999 27.1601 31.7302L62.7164 19.3119C63.1832 19.1515 63.9045 19.0077 64.3569 19.2048Z"
      fill="white"
    />
    <path
      d="M59.4638 52.696L56.5308 68.4217C56.4527 68.8317 56.2073 69.193 55.848 69.4269C55.4887 69.6609 55.0446 69.7486 54.6124 69.6708L23.0975 63.8548C22.8838 63.8152 22.6796 63.736 22.4967 63.6217C22.3137 63.5074 22.1556 63.3602 22.0314 63.1886C21.9072 63.017 21.8192 62.8243 21.7726 62.6215C21.726 62.4187 21.7217 62.2098 21.7598 62.0068L24.6881 46.2803C24.7291 46.0678 24.8151 45.8662 24.9407 45.6877C25.0664 45.5091 25.2292 45.3573 25.4192 45.2413C25.7705 45.0306 26.1946 44.9555 26.6065 45.0311L58.1221 50.8427C58.5545 50.9239 58.9384 51.1645 59.1898 51.5118C59.4412 51.8591 59.5397 52.2848 59.4638 52.696Z"
      fill="var(--brandSecondary)"
    />
    <path
      d="M58.903 51.4375L44.4065 58.917C43.0622 59.6098 41.5086 59.8357 40.0022 59.5575C38.4957 59.2793 37.1266 58.5136 36.121 57.3869L25.3057 45.2274C25.6565 45.0134 26.0795 44.9363 26.4899 45.0118L57.8967 50.8126C58.2993 50.8937 58.658 51.1165 58.903 51.4375Z"
      fill="var(--brandSecondary)"
    />
    <path
      opacity="0.5"
      d="M58.903 51.4375L44.4065 58.917C43.0622 59.6098 41.5086 59.8357 40.0022 59.5575C38.4957 59.2793 37.1266 58.5136 36.121 57.3869L25.3057 45.2274C25.6565 45.0134 26.0795 44.9363 26.4899 45.0118L57.8967 50.8126C58.2993 50.8937 58.658 51.1165 58.903 51.4375Z"
      fill="white"
    />
  </svg>
</template>